import BrandSearchBar from '@/layouts/BrandLayout/Components/BrandSearchBar.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    components: { BrandSearchBar },
    props: {
        query: Object,
    },
});
